import { Utilities } from '@shared/utilities/utilities.model';
import { AdditionalServices, DossierAndWorkingStates, MaintenanceTypes, ReplacementVehicleDuration, ReplacementVehicles, WorkingTypes } from '../../authority-shared/models/enums.model';
import { GlassStates } from './enums.model';
import { AuthorityAttachment } from '../../authority-shared/models/attachment.model';
import { ClaimModel } from '../../authority-shared/models/claim-model';
import { VehicleTypes } from '../../authority-shared/models/dossier.model';
import { PoDetailsModel } from 'app/authority/authority-shared/models/working.model';
import { AuthorityTemporaryAttachmentsErrorModel, AuthorityTemporaryAttachmentsWarningModel } from '@app/authority/authority-shared/adapters/AuthorityAttachmentsAdapter';

export class CarglassRequestDetail {
	address: string;
	aldId: string;
	branch: string;
	branchAddress: string;
	branchCity: string;
	branchPostalCode: string;
	carBrand: string;
	carModel: string;
	carPlate: string;
	plate: string;
	chassisNumber: string;
	city: string;
	complaintNumber: string;
	district: string;
	email: string;
	externalRequestId: string;
	fax: string;
	id: string;
	total: string;
	km: string;
	operatorNotes: string;
	outcomeChecks: string;
	outcomeChecksNotes: {
		checkStatus: GlassStatus,
		checklist: {
			checkStatus: GlassChecklistStatus,
			code: GlassChecklistCode,
			description: string
		}[]
	};
	postalCode: string;
	poDetails: PoDetailsModel[] = [];
	requestNote: string;
	requestedFixDate: string;
	status: GlassStates;
	checkStatus: GlassStatus;
	supplier: string;
	supplierCommercialName: string;
	supplierVatNumber: string;
	telephone: string;
	generalInformation: GeneralInformation;
	maintenanceInterventions: MaintenanceInterventions[];
	attachments: AuthorityAttachment[];
	attachmentUploadError?: {
		warnings? : AuthorityTemporaryAttachmentsWarningModel[];
		errors?   : AuthorityTemporaryAttachmentsErrorModel[];
	} = {};
	requestNumberPrefix: string;
	claims: ClaimModel[];
	error?: string;
	actions: GlassDetailActions;
	vehicleType: VehicleTypes;
	userGroup: string;
	userName: string;
	to_archive: boolean;
	archived: boolean;

	// inserito per adattare cristalli al nuovo Forza Canalizzazione
	type: WorkingTypes;

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.address = model.address;
			this.aldId = model.ald_id;
			this.branch = model.branch;
			this.branchAddress = model.branch_address;
			this.branchCity = model.branch_city;
			this.branchPostalCode = model.branch_postal_code;
			this.carBrand = model.car_brand;
			this.carModel = model.car_model;
			this.carPlate = model.car_plate;
			this.plate = model.car_plate;
			this.chassisNumber = model.chassis_number;
			this.city = model.city;
			this.complaintNumber = model.complaint_number;
			this.district = model.district;
			this.email = model.email;
			this.externalRequestId = model.external_request_id;
			this.fax = model.fax;
			this.id = model.id;
			this.total = model.total;
			this.km = model.km;
			this.operatorNotes = model.operator_notes;
			this.outcomeChecks = model.outcome_checks;
			this.outcomeChecksNotes = {
				checkStatus: model.outcome_checks_notes.check_status,
				checklist: model.outcome_checks_notes.checklist ? model.outcome_checks_notes.checklist.map(el => ({
					checkStatus: el.check_status,
					code: el.code,
					description: el.description
				})) : []
			};
			if (model.po_details) {
				model.po_details.forEach(el => {
					const poDetail: PoDetailsModel = new PoDetailsModel(el);
					this.poDetails.push(poDetail);
				});
			}
			this.postalCode = model.postal_code;
			this.requestNote = model.request_note;
			this.requestedFixDate = model.requested_fix_date;
			this.status = model.status;
			this.checkStatus = model.check_status;
			this.supplier = model.supplier;
			this.supplierCommercialName = model.supplier_commercial_name;
			this.supplierVatNumber = model.supplier_vat_number;
			this.telephone = model.telephone;
			this.requestNumberPrefix = model.request_number_prefix;
			this.claims = model.claims ? model.claims.map(c => new ClaimModel(c)) : [];
			this.error = model.error;
			this.vehicleType = model.vehicle_type;
			this.actions = new GlassDetailActions(model.actions);
			if (!Utilities.isVoid(model.general_information)) {
				this.generalInformation = new GeneralInformation(model.general_information);
			}
			this.maintenanceInterventions = [];
			if (!Utilities.isVoid(model.maintenance_interventions)) {
				model.maintenance_interventions.forEach(operation => this.maintenanceInterventions.push(new MaintenanceInterventions(operation)));
			}
			this.attachments = [];
			if (!Utilities.isVoid(model.attachments)) {
				model.attachments.forEach(attachment => this.attachments.push(new AuthorityAttachment(attachment)));
			}
			if (!Utilities.isEmpty(model.attachment_upload_error)) {
				const errList = model.attachment_upload_error;
				this.attachmentUploadError = {
					warnings : errList.warnings ? errList.warnings.map(x => new AuthorityTemporaryAttachmentsWarningModel(x)) : [],
					errors   : errList.errors ? errList.errors.map(x => new AuthorityTemporaryAttachmentsErrorModel(x)) : [],
				};
			}

			this.userGroup = model.user_group;
			this.userName = model.user_name;
			this.to_archive = model.to_archive;
			this.archived = model.archived;
			this.type = WorkingTypes.GLASS;
		}
	}

	/**
	 * Indica se l'intervento cristalli è chiuso-archiviato
	 * Le pratiche associate all'intervento cristalli archiviato non possono essere canalizzate
	 * 
	 * @returns {boolean}
	 */
	isArchived(): boolean {
		// return true;
		return !!this.archived;
	}
}

export class MaintenanceInterventions {

	eurocode: string;
	side: string;
	price: number;
	glassType: string;
	interventionType: string;
	listPrice: string;

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.eurocode = model.eurocode;
			this.side = model.side;
			this.price = model.price;
			this.glassType = model.glass_type;
			this.interventionType = model.intervention_type;
			this.listPrice = model.list_price;
		}
	}
}

export class GeneralInformation {

	driverId: string;
	driverFirstName: string;
	driverLastName: string;
	brand: string;
	model: string;
	plate: string;
	contractExpirationDate: string;
	lastRevisionDate: string;
	fuelType: string;
	status: DossierAndWorkingStates;
	warrantyActive: boolean;
	kw: string;
	replacementVehicle: ReplacementVehicles;
	replacementVehicleDuration: ReplacementVehicleDuration;
	maintenanceType: MaintenanceTypes;
	additionalServices: AdditionalServices[];

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.driverId = model.driver_id;
			this.driverFirstName = model.driver_first_name;
			this.driverLastName = model.driver_last_name;
			this.brand = model.brand;
			this.model = model.model;
			this.plate = model.plate;
			this.contractExpirationDate = model.contract_expiration_date;
			this.lastRevisionDate = model.last_revision_date;
			this.fuelType = model.fuel_type;
			this.status = model.status;
			this.warrantyActive = model.warrantyActive;
			this.replacementVehicle = model.replacementVehicle;
			this.replacementVehicleDuration = model.replacementVehicleDuration;
			this.maintenanceType = model.maintenanceType;
			this.kw = model.kw;
			this.additionalServices = [];
			if (!Utilities.isVoid(model.additionalServices)) {
				this.additionalServices = model.additionalServices;
			}
		}
	}
}

export enum GlassStatus {
	TO_AUTHORIZE = 'TO_AUTHORIZE',
	TO_REJECT		 = 'TO_REJECT',
	AUTHORIZED	 = 'AUTHORIZED',
	REJECTED		 = 'REJECTED',

	// CO 7055
	// inserito nuovo stato CANCELLATO
	// lo stato non esise a DB
	CANCELED		 = 'CANCELED',


	/**
	 *  Stati finti - non esistono a BE
	 * 	quando selezionati devono esssere gestiti in questo modo:
	 * 
	 * 	- AUTHORIZED_TO_BE_ARCHIVED va mandato a BE con
	 *     status=AUTHORIZED & to_archive=true
	 * 
	 * 	- REJECTED_TO_BE_ARCHIVED va mandato a BE con
	 *     status=REJECTED & to_archive=true
	 * 
	 *  vale solo per la ricerca degli interventi attivi
	 * 
	 *  
	 *  inserito con performance archiviazione
	 *  le pratiche chiuse hanno un periodo di retention
	 *  (30 giorni) in cui rimangono nel DB Attivo.
	 * 	Finito il periodo viene passata nel DB Archivio.
	 * 
	 *  18/03/2025 - gli stati finti non esistono più neanche a FE
	 * 
	 */ 
	// AUTHORIZED_TO_BE_ARCHIVED = 'AUTHORIZED_TO_BE_ARCHIVED',
	// REJECTED_TO_BE_ARCHIVED		= 'REJECTED_TO_BE_ARCHIVED',
 
}

export enum GlassChecklistStatus {
	OK = 'OK',
	KO = 'KO'
}

export enum GlassChecklistCode {
	PLATE = 'PLATE',
	CLAIM = 'CLAIM',
	COSTS = 'COSTS'
}

export class GlassDetailActions {
	canBeApproved: boolean;
	canBeRejected: boolean;
	canBeAssociated: boolean;

	constructor(model?: any) {
		if (model) {
			this.canBeApproved = model.can_be_approved;
			this.canBeRejected = model.can_be_rejected;
			this.canBeAssociated = model.can_be_associated;
		}
	}
}
